var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 105,
    viewBox: "0 0 104 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/heart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M71.2403 13.8704C63.397 13.8704 56.377 17.6837 52.0003 23.5337C47.6237 17.6837 40.6037 13.8704 32.7603 13.8704C19.457 13.8704 8.66699 24.7037 8.66699 38.0937C8.66699 43.2504 9.49033 48.017 10.9203 52.437C17.767 74.1037 38.8703 87.0604 49.3137 90.6137C50.787 91.1337 53.2137 91.1337 54.687 90.6137C65.1303 87.0604 86.2337 74.1037 93.0803 52.437C94.5103 48.017 95.3337 43.2504 95.3337 38.0937C95.3337 24.7037 84.5437 13.8704 71.2403 13.8704Z",
    fill: "#27C6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.7e80015f1fd1789c408f59094050ff02.svg";
export { ForwardRef as ReactComponent };